import React, { useState } from "react";
import InfluencerLogin from "./InfleuncerLogin/InfluencerLogin";
import BrandLogin from "./BrandLogin/BrandLogin";
import styles from "./Login.module.css";
//import formImage from "../../assets/formImage.png";
//import {  useNavigate } from "react-router-dom";
import inggage from "../../assets/inggage.png";
import login_Image from "../../assets/images/login_Image.png";

const Login = () => {
  const [isBrand, setIsBrand] = useState(false);

  const toggleSwitch = () => {
    setIsBrand(!isBrand);
  };

  return (
    <div className={styles.LoginForm}>
      <div className={styles.formImage}>
        <img src={login_Image} alt="form" />
      </div>
      <div className={styles.ToggleForms}>
        <div className={styles.toggleLogin}>
          <div className="flex justify-center items-center my-4">

          <div className="w-full  bg-white rounded-lg border-2 border-gray-200 py-4 px-12">

            <h2 className="mb-2">Login</h2>
            <div className="flex items-center gap-1 text-bold text-[#EA0063] mb-2">
              <span
                className={!isBrand ? styles.activeLabel : styles.inactiveLabel}
              >
                Creator
              </span>
              <div className={styles.switch} onClick={toggleSwitch}>
                <div
                  className={`${styles.slider} ${
                    isBrand ? styles.sliderActive : ""
                  }`}
                />
              </div>
              <span
                className={isBrand ? styles.activeLabel : styles.inactiveLabel}
              >
                Brand
              </span>
              <div></div>
            </div>

            <div>{isBrand ? <BrandLogin /> : <InfluencerLogin />}</div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
